export class IDeliveryAddress {
   _id: string;
   street: string;
   city: string;
   country: string;
   state: string;
   zipCode: string;
}